@if (useCountryObject) {
  <app-form-field label="Country" [renderOptional]="renderOptional" [editMode]="editMode"
                  [value]="country?.name" [formatter]="countryFormatter" [includeMargin]="includeMargin">
    <app-search [(ngModel)]="country" [searchFunction]="portVisitUtils.findCountries"
                [inputFormatter]="countryFormatter" [resultFormatter]="countryFormatter"
                (ngModelChange)="onCountryChange($event)" [required]="required" [minCharacters]="0"
                placeholder="Find country by name or country code" class="input-group">
    </app-search>
  </app-form-field>
} @else {
  <app-form-field label="Country" [renderOptional]="renderOptional" [editMode]="editMode"
                  [(value)]="countryCode" [formatter]="countryFormatter" [includeMargin]="includeMargin">
    <app-search [(ngModel)]="countryCode" [searchFunction]="portVisitUtils.findCountries"
                [inputFormatter]="countryFormatter" [resultFormatter]="countryFormatter"
                (ngModelChange)="onCountryChange($event)" [required]="required" [minCharacters]="0"
                placeholder="Find country by name or country code" class="input-group">
    </app-search>
  </app-form-field>
}
